import React, { memo, useCallback, Fragment } from 'react';
import { camelize } from 'humps';
import { Link } from 'react-router-dom';

import { Spinner } from '../../helpers/Spinner';

import style from '../style.module.css';

const TeamLevelBenchmarksTableComponent = ({ benchmarks, isLoading, isEditState, onChange }) => {
  const renderRow = useCallback(
    team => {
      const moduleLabel = team.get('module');
      const columns = benchmarks.get('teamColumns');

      return (
        <Fragment key={moduleLabel}>
          <tr className="text-bold row-module">
            <td className="text-uppercase">{moduleLabel} Module</td>
            {columns.map((column, index) => (
              <td key={index} />
            ))}
          </tr>
          {team.get('children').size > 0 ? (
            team.get('children')?.map(child => {
              const id = child.get('teamId');

              return (
                <tr key={id} className="text-bold name-column">
                  <td>{child.get('team')}</td>

                  {columns.map((column, index) => {
                    const metricKey = camelize(column.get('key'));
                    const metric = child.getIn(['metrics', metricKey]);
                    const benchmark = metric?.get('benchmark');
                    const avg = metric?.get('avg');

                    return (
                      <td key={index} className="text-right">
                        <div className={style.cell}>
                          <input
                            className={style.cellInputValue}
                            disabled={!isEditState}
                            min="0"
                            onChange={event => onChange(id, column.get('key'), event.target.value)}
                            step="1"
                            type="number"
                            value={benchmark ?? '0'}
                          />
                          <div className="label label-muted font-size-10">
                            avg {avg != null ? Number(avg).toFixed(2) : '-'}
                          </div>
                        </div>
                      </td>
                    );
                  })}
                </tr>
              );
            })
          ) : (
            <tr>
              <td className="text-bold" colSpan={columns.size + 1}>
                You don&#39;t have any Teams or Direct Reports. &nbsp;
                <Link className="btn link" to="/director-dashboard/module-settings">
                  Update teams and users in Module Settings.
                </Link>
              </td>
            </tr>
          )}
        </Fragment>
      );
    },
    [benchmarks, isEditState, onChange],
  );

  return (
    <div className="position-relative">
      {isLoading && <Spinner />}
      <div className="table-responsive">
        <table className="table table-blue table-hover mb0">
          <thead>
            <tr className="col-groups">
              <th rowSpan="2">Team / Module</th>
              <th colSpan="3">Approaches (Outreach)</th>
            </tr>
            <tr className="col-headers">
              {benchmarks?.get('teamColumns')?.map(column => (
                <th key={column.get('key')}>{column.get('label')}</th>
              ))}
            </tr>
          </thead>
          <tbody>{benchmarks?.get('teams')?.map(team => renderRow(team))}</tbody>
        </table>
      </div>
    </div>
  );
};

export const TeamLevelBenchmarksTable = memo(TeamLevelBenchmarksTableComponent);
